<template>
    <div class="page_czj flex-col">
        <div class="block_54 flex-col">

            <div class="group_70 flex-col">
                <div class="text-group_231 flex-col justify-between">
                    <span class="text_199">为什么选择我们</span>
                    <span class="text_200">CORE STRENGTH</span>
                </div>
                <div class="group_108 flex-row justify-between">
                    <div class="group_109 flex-col">
                        <div
                                v-for="(item, index) in items"
                                :key="index"
                                class="flex-row"
                                :class="activeIndex === index ? (index === 0 ? 'section_33_hover_first' : 'section_33_hover')
      : 'section_33'"
                                @click="handleSelectIndex(index)"
                                @mouseover="hoverIndexFun(index) "
                                @mouseleave="offhoverIndexFun"
                        >
                            <img class="label_11" :src="item.icon" />
                            <span :class="['text', activeIndex === index ? 'text_201' : 'text_202']">
                {{ item.text }}
              </span>
                        </div>
                    </div>
                    <div class="group_73 flex-col">
                        <img
                                class="image_37"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_core_select03.png"
                        />
                        <div class="image-text_195 flex-row justify-between">
                            <img
                                    class="thumbnail_9"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/home/chpc_about_industry_02.png"
                            />
                            <transition name="fade" mode="out-in">
                <span class="text-group_147" :key="activeIndex">
                  {{ items[activeIndex].content }}
                </span>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectedIndex:0,
                hoverIndex:-1,
                activeIndex: 0, // 当前激活的条目索引
                items: [
                    {
                        icon: require('../../../assets/home/chpc_about_industry_03.png'),
                        text: '定制化诊断精准匹配企业健康需求',
                        content:'基于100余家药械及大健康行业客户服务经验，构建“业务-财务-合规”三维诊断模型，覆盖学术推广、渠道窜货、费用黑洞等20+风险场景，精准识别业务盲区，为企业提供深度定制化健康方案。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_04.png'),
                        text: '跨部门协同解决方案',
                        content:'打通销售、财务、供应链等多部门数据壁垒，通过智慧化综合评估系统与资深人员专业研判，量化风险敞口与增长潜力，提供端到端优化策略。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_05.png'),
                        text: '全链路诊断营销效能',
                        content:'全链路核查营销活动的计划管理、落地实施、结果产出，进行费用与效果关联分析，诊断识别无效投入与潜力场景，重构资源分配策略，助力客户营销ROI提升。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_06.png'),
                        text: '数字化赋能工具',
                        content:'自主研发企业健康智慧中心，涵盖AI作业工具集与多维风险评估平台，集成风险预警、合规自检、决策模拟等功能，实现风险管理的实时化与可视化。',
                    }
                ],
                constants: {}
            };
        },
        methods: {
            handleSelectIndex(index){
                this.activeIndex = index;
                this.selectedIndex = index;
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.activeIndex = index;
            },
            offhoverIndexFun(){
               // this.activeIndex = this.selectedIndex ;
               // this.hoverIndex = -1;
            },
        }
    };
</script>
<style scoped lang="css"  >
    .page_czj {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .block_54 {
        position: relative;
        width: 1468px;
        margin-bottom: 1px;
        align-items: center;
    }

    .group_70 {
        background-color: rgba(255, 255, 255, 1);
        width: 1200px;
        height: 600px;
        align-items: center;
    }

    .text-group_231 {
        width: 100%;
        height: 96px;
        margin: 50px 0 0 0;
        align-items: center;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_199 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_200 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .group_108 {
        width: 1105px;
        height: 355px;
        margin: 39px 0 60px 0;
    }

    .group_109 {
        width: 520px;
        height: 355px;
        gap: 28px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_33_hover {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px;
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }
    .section_33_hover_first {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px; /* 去除上边距 */
        transition: all 0.3s;
        cursor: pointer;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_33 {
        border-radius: 4px;
        width: 510px;
        height: 69px;
        border: 1px solid rgba(232, 232, 232, 1);
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }

    .label_11 {
        width: 22px;
        height: 24px;
        margin: 20px 0 0 25px;
    }

    .text_201 {
        width: 382px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(0, 120, 126, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 19px 64px 0 27px;
    }
    .text_202 {
        width: 360px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 77px 0 26px;
    }

    .group_73 {
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 1);
        width: 548px;
        height: 351px;
    }

    .image_37 {
        width: 550px;
        height: 120px;
        margin-left: -1px;
    }

    .image-text_195 {
        width: 501px;
        height: 180px;
        margin: 20px 0 31px 12px;
    }

    .thumbnail_9 {
        width: 12px;
        height: 14px;
        margin-top: 8px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .text-group_147 {
        width: 478px;
        height: 180px;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 30px;
    }

</style>
